<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="alipyAccountSetForm" :model="alipyAccountSetForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="公司名称">
                <el-input v-model="alipyAccountSetForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getAlipyAccountList">查询</el-button>
            <el-button type="primary" @click="addAlipyAccount">添加</el-button>
            <el-button type="primary" @click="switchPayTest">切换支付测试</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="appId"
            label="appId">
          </el-table-column>
          <el-table-column
            prop="type"
            label="支付对象">
            <template slot-scope="scope">
              <span v-if="scope.row.type === '1'">第三方</span>
              <span v-else>自营</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorAlipyAccount(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === 1">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="payTest(scope.row.id)" type="text" size="small" style="color: red;">测试支付</el-button>
                <!-- <el-button @click="deleteAlipyAccount(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> -->
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑支付账号' : '新建支付账号'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editalipyAccountSetForm" :model="editalipyAccountSetForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editalipyAccountSetForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="name">
              <el-input v-model="editalipyAccountSetForm.name"></el-input>
            </el-form-item>
            <el-form-item label="appID" prop="appId">
              <el-input v-model="editalipyAccountSetForm.appId"></el-input>
            </el-form-item>
            <el-form-item label="应用私钥" prop="appPrivateKey">
              <textarea v-model="editalipyAccountSetForm.appPrivateKey" style="width: 100%;height: 90px;"></textarea>
            </el-form-item>
            <el-form-item label="支付宝公钥" prop="alipayPublicKey">
              <textarea v-model="editalipyAccountSetForm.alipayPublicKey" style="width: 100%;height: 90px;"></textarea>
            </el-form-item>
            <el-form-item label="回调路径" prop="notifyUrl">
              <el-input v-model="editalipyAccountSetForm.notifyUrl"></el-input>
            </el-form-item>
            <el-form-item label="网关地址" prop="serverUrl">
              <el-input v-model="editalipyAccountSetForm.serverUrl"></el-input>
            </el-form-item>
            <el-form-item label="支付对象" prop="type">
              <el-radio class="radio" v-model="editalipyAccountSetForm.type" label="1">第三方</el-radio>
              <el-radio class="radio" v-model="editalipyAccountSetForm.type" label="2">自营</el-radio>
            </el-form-item>
            <el-form-item label="备用支付账号ID" prop="backupPayChannelId">
              <el-input v-model="editalipyAccountSetForm.backupPayChannelId"></el-input>
            </el-form-item>
            <el-form-item label="支付账号" prop="testAccount">
              <el-input v-model="editalipyAccountSetForm.testAccount"></el-input>
            </el-form-item>
            <el-form-item label="支付姓名" prop="testName">
              <el-input v-model="editalipyAccountSetForm.testName"></el-input>
            </el-form-item>
            <!-- <el-form-item label="金额" prop="testMoney">
              <el-input v-model="editalipyAccountSetForm.testMoney"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      alipyAccountSetForm: {
        name: null
      },
      categoryOptions: [],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editalipyAccountSetForm: {
        id: null,
        type: 1
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        // tempGradeIdList: [
        //   { required: true, message: '请选择前端等级', trigger: 'change' },
        // ],
        autoPriceGradeId: [
          { required: true, message: '请选择出价等级', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      queryGradeList:[]
    }
  },
  watch:{},
  computed:{},
  methods:{
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    deleteAlipyAccount(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteAlipyAccount({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getAlipyAccountList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getAlipyAccountList()
    }, 
    //等级
    getGradeList(val) {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: self.editalipyAccountSetForm.categoryId,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
             
            });
    },

    // 获取门店列表
    getAlipyAccountList() {
      let self  = this;
      self.$api.listSearchAlipyAccount({
        page: self.currentPage,
        size: self.pageSize,
        name: self.alipyAccountSetForm.name || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addAlipyAccount() {
      this.dlgType = 'new'
      this.editalipyAccountSetForm =  {
        id: null,
        type: "1"
      }
      this.$nextTick(()=>{
          this.$refs['editalipyAccountSetForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorAlipyAccount(row) {
      let self = this;
      self.editalipyAccountSetForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editalipyAccountSetForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateAlipyAccount(self.editalipyAccountSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getAlipyAccountList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addAlipyAccount(self.editalipyAccountSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getAlipyAccountList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 开启门店
    open(id) {
      let self = this
      this.$api.openAlipyAccount(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getAlipyAccountList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeAlipyAccount(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getAlipyAccountList()
        }
      })
    },
    // 支付测试
    payTest(id) {
      let self = this
      this.$api.payTest(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: res.data,
            type: 'success'
          });
        }
      })
    },
    // 切换测试
    switchPayTest() {
      let self = this
      this.$api.switchPayTest().then(res => {
        if(res.code === 200) {
          this.$message({
            message: res.data,
            type: 'success'
          });
        }
      })
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getAlipyAccountList();
    self.getSelectOptions("category", "categoryOptions");
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>